// Imported here rather than angular.json's `polyfills`, which treats any
// `.ts` entry as a Zone.js app and downlevels async/await across the bundle.
import './polyfills';
import { provideHttpClient, withXhr } from '@angular/common/http';
import {
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Drivers } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { BugSplatLogger, BugSplatLogLevel, BugSplatModule } from 'bugsplat-ng';
import { provideMarkdown } from 'ngx-markdown';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { MyAngularErrorHandlerService } from './app/common/error-handler/my-angular-error-handler.service';
import { environment } from './environments/environment';

defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

const optionalProviders = environment.bugsplat
  ? [
      importProvidersFrom(BugSplatModule.initializeApp(environment.bugsplat)),
      {
        provide: ErrorHandler,
        useClass: MyAngularErrorHandlerService,
      },
      {
        provide: BugSplatLogger,
        useValue: new BugSplatLogger(BugSplatLogLevel.log),
      },
    ]
  : [];

async function createStorageInstance(): Promise<Storage> {
  const storage = new Storage({
    name: 'HeyBibleStorage',
    driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
  });
  return await storage.create();
}

async function main() {
  const supabaseClient = createClient(
    environment.supabaseUrl,
    environment.supabaseKey
  );

  const storageInstance = await createStorageInstance();

  await bootstrapApplication(AppComponent, {
    providers: [
      provideZonelessChangeDetection(),
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: SupabaseClient, useValue: supabaseClient },
      { provide: Storage, useValue: storageInstance },
      provideIonicAngular({ mode: 'ios', innerHTMLTemplatesEnabled: true }),
      provideHttpClient(withXhr()),
      provideMarkdown(),
      provideRouter(routes, withComponentInputBinding()),
      ...optionalProviders,
    ],
  });
}

main().catch((err) => console.error('Error starting app:', err));
